import { MutationConfig } from '@helpers';
import { useMutation, useQueryClient } from 'react-query';
import { getLinksReviewQueryOptions } from './get-links-management';
import { ApiClientEnterpriseLinksReview } from '@helpers/apiClients';
import { EditMultipleEnterpriseLinksManagementInput } from '../types';
import { successMessage } from '@services';

export const editMultipleLinksManagement = ({
  companyId,
  data,
}: {
  companyId: string;
  data: EditMultipleEnterpriseLinksManagementInput;
}) => {
  return ApiClientEnterpriseLinksReview.put(
    `/enterprise/${companyId}/link-reviews/batch-update`,
    data,
  );
};

type UseEditMultipleLinksManagementOptions = {
  mutationConfig?: MutationConfig<typeof editMultipleLinksManagement>;
};

export const useEditMultipleLinksReview = ({
  mutationConfig,
}: UseEditMultipleLinksManagementOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: (...args) => {
      successMessage('Links updated successfully');
      queryClient.invalidateQueries({
        queryKey: getLinksReviewQueryOptions().queryKey,
      });
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: editMultipleLinksManagement,
  });
};
